import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';
import BackGroundImage from './BackgroundImage';

const Container = styled.div`
  margin-top: 144px;
  grid-column: span 24;
  position: relative;
  @media (max-width: 70.95em) {
    margin-top: 102px;
  }
`;

const MissionGroup = styled.div`
  grid-column: span 11;
  margin-bottom: 80px;
  margin-top: 64px;
  @media (max-width: 70.95em) {
    grid-column: span 12;
    margin-bottom: 36px;
  }
  @media (max-width: 70.95em) {
    grid-column: span 24;
    width: 100%;
    margin-top: 32px;
  }
`;

const Mission = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 2px;
  color: #08bd80;
  @media (max-width: 70.95em) {
    display: block;
    font-size: 12px;
    text-align: center;
  }
`;

const Description = styled.h2`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #3c4852;
  margin-top: 16px;
  @media (max-width: 70.95em) {
    font-size: 24px;
    text-align: center;
  }
`;

const Journey = styled.div`
  grid-column: span 24;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  @media (max-width: 70.95em) {
    display: grid;
    grid-template-columns: repeat(24, 1fr);
    grid-column-gap: 8px;
    grid-row-gap: 8px;
  }
`;

const HistoryHolder = styled.div`
  grid-column: span 13;
  margin-top: 112px;
  @media (max-width: 70.95em) {
    margin-top: 0px;
  }
  @media (max-width: 70.95em) {
    grid-column: span 24;
    width: 100%;
    padding: 0 16px;
  }
`;

const History = styled.div`
  padding-bottom: 60px;
  position: relative;
  @media (max-width: 70.95em) {
    margin-bottom: 56px;
  }
  @media (max-width: 70.95em) {
    padding-bottom: 40px;
    margin-bottom: 0;
  }
`;

const Year = styled.span`
  font-weight: bold;
  font-size: 32px;
  line-height: 120%;
  color: #3c4852;
  @media (max-width: 70.95em) {
    margin-top: 20px;
    font-size: 24px;
    text-align: center;
  }
`;

const SubText = styled.div`
  font-size: 24px;
  line-height: 150%;
  color: #627984;
  padding-left: 76px;
  @media (max-width: 70.95em) {
    padding-left: 0px;
    margin-top: 12px;
    font-size: 14px;
    text-align: center;
  }
`;

const Image = styled.img`
  width: 80px;
  padding-right: 24px;
  z-index: 1;
  object-fit: contain;
  @media (max-width: 70.95em) {
    padding-right: 0px;
  }
  @media (max-width: 70.95em) {
    width: 40px;
    height: auto;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 70.95em) {
    flex-direction: column;
    align-items: center;
  }
`;

const Line = styled.div`
  border-left: 4px dotted #d5e3ed;
  height: 99%;
  position: absolute;
  left: 25px;
  display: ${({ $display }) => ($display === 'lg' ? 'block' : 'none')};
  opacity: ${({ $opacity }) => $opacity};
  @media (max-width: 70.95em) {
    left: 50%;
    justify-content: center;
    align-items: center;
    border-width: 2px;
    display: ${({ $display }) => ($display === 'sm' ? 'flex' : 'none')};
  }
`;

const historys = [
  {
    image: 'about/youtube.png',
    year: '2015',
    subText:
      'From a YouTube channel that started in 2010, we became a feature-rich educational technology platform in 2015'
  },
  {
    image: 'about/postcard.png',
    year: '2017',
    subText:
      'Became India’s largest online learning platform with 1m+ learners & 40k live classes'
  },
  {
    image: 'about/live.png',
    year: '2018',
    subText:
      'Became the biggest Live Learning platform with 200k+ daily active users who are learning with live classes'
  },
  {
    image: 'about/rocket.svg',
    year: '2020',
    subText:
      'We acquired Kreatryx, PrepLadder and Codechef to encompass more avenues of learning, we also launched our own Graphy app for enjoying interactive stories & books'
  }
];

const JourneyBlock = () => {
  return (
    <Container>
      <BackGroundImage src={imageHelper.getImage('about/quote.png')} />
      <Journey>
        <MissionGroup>
          <Mission>FROM HUMBLE BEGINNINGS</Mission>
          <Description>Our journey so far</Description>
        </MissionGroup>
        <HistoryHolder>
          {historys.map((history, index) => (
            <History key={history.image}>
              <ImgContainer>
                {historys.length - 1 !== index && (
                  <Line $display="sm" $opacity={(4 - index) * 0.25} />
                )}
                <Image src={imageHelper.getImage(history.image)} />
                <Year>{history.year}</Year>
              </ImgContainer>
              {historys.length - 1 !== index && (
                <Line $display="lg" $opacity={(4 - index) * 0.25} />
              )}
              <SubText>{history.subText}</SubText>
            </History>
          ))}
        </HistoryHolder>
      </Journey>
    </Container>
  );
};

export default JourneyBlock;
